module.exports = __webpack_public_path__ + "static/jaeyoung.hwang-ee17fa0fc22c4c121434016d2a6a9a62.jpeg";